import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "../../core/translation.core";
import orderCore from "../../core/order.core";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";

export default function DeliveryStatusDisplay({ orderId }: { orderId: string }) {
  const { t, msg } = useTranslation();

  const {
    data: deliveryStatusData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["orderDeliveryStatus", orderId],
    queryFn: () => orderCore.getOrderDeliveryStatuses(orderId),
  });

  const getDeliveryStatusCss = (status: string) => {
    switch (status) {
      case "scheduled":
        return "text-white bg-gray-500";
      case "preparing":
        return "text-white bg-blue-700";
      case "onDelivery":
        return "text-white bg-[#2e9cdb]";
      case "canPickup":
        return "text-white bg-yellow-500";
      case "delivered":
        return "text-white bg-green-700";
      case "cancelled":
        return "text-white bg-red-400";
      default:
        return "text-white bg-gray-500";
    }
  };

  return (
    <div className="flex flex-wrap gap-1" data-role="delivery-statuses">
      {error ? (
        <span className="text-gray-500 dark:text-gray-400">{t(msg.delivery.notAvailable)}</span>
      ) : isLoading ? (
        <div className="flex items-center">
          <LoadingOvalCenterIcon />
        </div>
      ) : deliveryStatusData?.deliveryStatuses && deliveryStatusData.deliveryStatuses.length > 0 ? (
        deliveryStatusData.deliveryStatuses.map((status) => {
          const translatedStatus = orderCore.getDeliveryStatusLocale(status, { t, msg });
          return (
            <span
              key={status}
              className={`inline-block px-2 py-1 text-xs font-medium rounded-lg ${getDeliveryStatusCss(status)}`}
            >
              {translatedStatus || status}
            </span>
          );
        })
      ) : (
        <span className="text-gray-500 dark:text-gray-400">{t(msg.delivery.notAvailable)}</span>
      )}
    </div>
  );
}
